import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import poweredLogo from "../../../src/assets/images/PoweredNew.png";
import { postRequest } from "../../api/http";
import userServiceApi from "../../api/userServiceApi";
import backBtn from "../../assets/images/back-arrow.svg";
import { LoadingView } from "../../common";

import "./Login.scss";
import { inputFieldCharLimit } from "../../config";

function ChangePassword() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const lastPage = sessionStorage.getItem("page");

  const onFinish = async (values) => {
    if (values.newPassword === values.confirmPwd) {
      delete values.confirmPwd;
      try {
        setLoading(true);
        const response = await postRequest(
          userServiceApi.changePassword(),
          values
        );
        if (response === "Success") {
          setLoading(false);
          toast.success("Password Updated Successfuly");
          setTimeout(() => {
            navigate("/partner-org");
          }, 1000)
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        toast.error(error.error);
      }
    } else {
      setLoading(false);
      toast.error("Password and Confirm Password does not match");
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.error("Failed:", errorInfo);
  };

  if (loading) return <LoadingView message="Loading..." />;

  return (
    <div className="tabContainer">
      <div className="main-container" style={{ paddingTop: "5px" }}>
        <div className="header-container">
          <div className="backbtn-container">
            <img src={backBtn}
              onClick={() => {
                lastPage === "home" ?
                  navigate('/partner-org') :
                  lastPage === "edit-carousel" ?
                    navigate('/carousel') :
                    lastPage === "full-members" ?
                      navigate('/full-members') :
                      lastPage === "hub-members" ?
                        navigate('/hub-members') :
                        navigate('/partner-org')
              }}
              alt="" />
            <p>Change password</p>
          </div>
        </div>
        <div className="formInfoStyle changePassword">
          <Form
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <div className="formInfoRow">
              <div className="formInfoCol">
                <Form.Item
                  label="Old Password"
                  name="currentPassword"
                  rules={[
                    { required: true, message: 'Please input your old password!' },
                  ]}                 >
                  <Input.Password placeholder="Old Password"
                    maxLength={inputFieldCharLimit}
                    iconRender={(visible) => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="formInfoRow">
              <div className="formInfoCol">
                <Form.Item
                  label="New Password"
                  name="newPassword"
                  hasFeedback
                  rules={[
                    { required: true, message: 'Please input your new password!' },
                    { min: 8, message: 'Password must be at least 8 characters long!' },
                    {
                      pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])(?!.*\s)/,
                      message: 'Password must include uppercase, lowercase, number, special character and must not contain spaces!',
                    },
                  ]}>
                  <Input.Password maxLength={inputFieldCharLimit} placeholder="New Password" iconRender={(visible) => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}

                  />
                </Form.Item>
              </div>
            </div>
            <div className="formInfoRow">
              <div className="formInfoCol">
                <Form.Item
                  label="Confirm Password"
                  name="confirmPwd"
                  hasFeedback
                  dependencies={['newPassword']}  // Add dependencies to revalidate when 'newPassword' changes
                  rules={[
                    { required: true, message: 'Please input your new password!' },
                    // { min: 8, message: 'Password must be at least 8 characters long!' },
                    // {
                    //   pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])/,
                    //   message: 'Password must include uppercase, lowercase, number, and special character!',
                    // }, 
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('newPassword') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('Passwords do not match'));
                      },
                    }),
                  ]}                  >
                  <Input.Password maxLength={inputFieldCharLimit} placeholder="Confirm Password" iconRender={(visible) => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="formInfoRow">
              <div className="formInfoCol">
                <Form.Item label=" " colon={false}>
                  <div className="form-btn-container" >
                    <Button
                      className="form-cancel-btn"
                      onClick={() => {
                        navigate("/partner-org");
                      }}
                    >
                      Cancel
                    </Button>
                    <Button className="form-save-btn" htmlType="submit" onClick={() => form.submit()}>
                      Update
                    </Button>
                  </div>
                </Form.Item>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div >
  );
}

export default ChangePassword;
